module.exports = __webpack_public_path__ + "img/about.49b7ae80.png";